import React, { useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomModal from '../components/CustomModal';
import CustomButton from '../components/CustomButton';
import ConsultationForm from '../components/ConsultationForm';
import api from '../api';
import { useAuth } from '../auth/AuthContext';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function Consultation() {
  const navigate = useNavigate();
  const location = useLocation();
  const formRef = useRef(null);
  const { user } = useAuth() || {};
  const storedPatient = sessionStorage.getItem("patient");
  const patient = storedPatient ? JSON.parse(storedPatient) : null;
  const research_id = patient?.research_id || user?.id || "P010";

  const goBack = () => {
    if (location.key !== 'default') navigate(-1);
    else navigate('/summary', { replace: true });
  };

  const handleSave = async (payload) => {
  try {
    console.log("送信データ:", payload);
    const res = await api.post("/v1/doctor/register_medical_info", {
      research_id,
      // consultation_date: payload.visitDate?.slice(0, 10),
      consultation_date: payload.visitDate
        ? dayjs(payload.visitDate).tz("Asia/Tokyo").format("YYYY-MM-DD")
        : null,

      edss_score: Number(payload.edssScore) || 0,
      drug_type: payload.prescribedDrug?.text || "",
      mri_result: payload.hasMriLesion === "1" ? "あり"
                    : payload.hasMriLesion === "0" ? "なし"
                    : "未実施",
      recent_recurrence: payload.hasRelapse === "1",
      doctor_comment: payload.doctorComment || "",
      // update_date: new Date().toISOString(),
      update_date: dayjs().tz("Asia/Tokyo").format(),

    });

    console.log("登録APIレスポンス:", res.data);
    alert(res.data?.message || "診察記録を保存しました。");
    goBack();
  } catch (err) {
    console.error("診察記録登録エラー:", err);
    alert("診察記録の登録に失敗しました。");
  }
};

  return (
    <CustomModal
      open
      title="診察を記録する"
      closeOnOverlay={false}
      size="lg"
      onClose={goBack}   // ← ×ボタン対応（CustomModal 側が onClose を呼ぶ）
      footer={
        <>
          <CustomButton kind="secondary" onClick={goBack}>キャンセル</CustomButton>
          <CustomButton kind="primary" onClick={() => formRef.current?.submit()}>
            保存
          </CustomButton>
        </>
      }
    >
      <ConsultationForm ref={formRef} onSubmit={handleSave} />
    </CustomModal>
  );
}
